/**
 * Post-test Analysis - Sonuç analizi sekmesi
 * 
 * Features:
 * - Variant input management
 * - Analysis settings configuration
 * - Results display
 * - Chart interactions
 */

import React from 'react';
import {
  Grid,
  Card,
  CardContent,
  Typography,
  LinearProgress
} from '@mui/material';
import VariantInputForm from './VariantInputForm';
import AnalysisSettings from './AnalysisSettings';
import ResultsTable from './ResultsTable';
import ResultsCharts from './ResultsCharts';

const PostTestAnalysis = ({
  variants,
  postTestSettings,
  postTestResults,
  loading,
  onVariantChange,
  onAddVariant,
  onRemoveVariant,
  onSettingsChange,
  onCalculate,
  onClear,
  onShowChart,
  resultsTableRef,
  showSampleButton,
  onLoadSampleData,
}) => {
  return (
    <Grid container spacing={3}>
      {/* Variant Input Section */}
      <Grid item xs={12} lg={8}>
        <VariantInputForm
          variants={variants}
          onVariantChange={onVariantChange}
          onAddVariant={onAddVariant}
          onRemoveVariant={onRemoveVariant}
          showSampleButton={showSampleButton}
          onLoadSampleData={onLoadSampleData}
          loading={loading}
        />
      </Grid>

      {/* Settings Section */}
      <Grid item xs={12} lg={4}>
        <AnalysisSettings
          postTestSettings={postTestSettings}
          loading={loading}
          onSettingsChange={onSettingsChange}
          onCalculate={onCalculate}
          onClear={onClear}
        />
      </Grid>

      {/* Visual results */}
      {postTestResults && (
        <Grid item xs={12}>
          <ResultsCharts
            postTestResults={postTestResults}
            postTestSettings={postTestSettings}
            onShowChart={onShowChart}
          />
        </Grid>
      )}

      {/* Results table */}
      {postTestResults && (
        <Grid item xs={12}>
          <ResultsTable
            postTestResults={postTestResults}
            postTestSettings={postTestSettings}
            onShowChart={onShowChart}
            resultsTableRef={resultsTableRef}
          />
        </Grid>
      )}

      {/* Loading Section */}
      {loading && (
        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Analiz ediliyor...
              </Typography>
              <LinearProgress />
            </CardContent>
          </Card>
        </Grid>
      )}
    </Grid>
  );
};

export default PostTestAnalysis; 